import React from "react";
import { FormattedMessage } from "react-intl";

import CardItem from "./CardItem";

interface IIncotermCardProps {
  incoterm: string;
}

function IncotermCard({ incoterm }: IIncotermCardProps) {
  return (
    <CardItem>
      <p className="font-b3 text-secondary">
        <FormattedMessage id="settings.payment-locations.incoterm" defaultMessage="Incoterms" />
      </p>
      {incoterm ? (
        <>
          <p className="font-b4">{incoterm.split("-")[0]}</p>
          <p className="font-b3">{incoterm.split("-")[1]}</p>
        </>
      ) : (
        "-"
      )}
    </CardItem>
  );
}

export default IncotermCard;
